import { FirmwareStatusState, RemoteFlashActionTypes, RemoteFlashActionNames } from './types';

const initialState: FirmwareStatusState = {
  firmwareStatus: {},
  softwareFileExistsInDb: false,
  hashExistsInDb: '',
};

export const remoteFlashReducer = (
  state: FirmwareStatusState = initialState,
  action: RemoteFlashActionTypes,
): FirmwareStatusState => {
  switch (action.type) {
    case RemoteFlashActionNames.SET_FIRMWARE_STATUS: {
      return {
        ...state,
        firmwareStatus: action.payload,
      };
    }
    case RemoteFlashActionNames.SET_FILE_EXISTS_IN_DB: {
      return {
        ...state,
        softwareFileExistsInDb: action.payload,
      };
    }
    case RemoteFlashActionNames.SET_HASH_EXISTS_IN_DB: {
      return {
        ...state,
        hashExistsInDb: action.payload,
      };
    }
    default:
      return state;
  }
};
